import React from 'react';
import '../styles/contact.css';
import { 
  contactEmail, 
  businessEmail, 
  facebookUrl, 
  twitterUrl, 
  instagramUrl, 
  linkedinUrl 
} from '../utils/contactInfo';

const Contact = () => {
  return (
    <>
      <section className="page-header">
        <div className="container">
          <h2>Get in Touch</h2>
        </div>
      </section>

      <section className="contact-content">
        <div className="container">
          <div className="contact-intro">
            <p>Have a question, suggestion, or just want to say hello? Jesse and Josh would love to hear from you! Reach out through email or any of our social media channels.</p>
          </div>

          <div className="contact-grid">
            <div className="contact-direct">
              <h3>Contact Us</h3>
              <div className="contact-card">
                <p>For any inquiries, feedback, or questions, please email us at:</p>
                <p className="contact-email">{contactEmail}</p>
                
                <div className="contact-note">
                  <h4>Want to be a Guest?</h4>
                  <p>Jesse and Josh are always looking for interesting guests to feature on our podcast. If you'd like to be a guest, please email us with:</p>
                  <ul>
                    <li>Your name and background</li>
                    <li>Topics you'd like to discuss</li>
                    <li>Your experience with containers, Kubernetes, or cloud-native technologies</li>
                    <li>Links to your website, social media, or previous talks/interviews</li>
                  </ul>
                  <p>We review all guest applications and will get back to you if we think you'd be a good fit for the show!</p>
                </div>
              </div>
            </div>

            <div className="contact-info">
              <h3>Other Ways to Connect</h3>
              <div className="info-item">
                <h4>Email</h4>
                <p><a href={`mailto:${contactEmail}`}>{contactEmail}</a></p>
              </div>
              <div className="info-item">
                <h4>Social Media</h4>
                <div className="social-grid">
                  {facebookUrl && (
                    <a href={facebookUrl} className="social-item" target="_blank" rel="noopener noreferrer">
                      <img src="https://cdn-icons-png.flaticon.com/512/733/733547.png" alt="Facebook" />
                      <span>Facebook</span>
                    </a>
                  )}
                  {twitterUrl && (
                    <a href={twitterUrl} className="social-item" target="_blank" rel="noopener noreferrer">
                      <img src="https://cdn-icons-png.flaticon.com/512/733/733579.png" alt="Twitter" />
                      <span>Twitter</span>
                    </a>
                  )}
                  {instagramUrl && (
                    <a href={instagramUrl} className="social-item" target="_blank" rel="noopener noreferrer">
                      <img src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png" alt="Instagram" />
                      <span>Instagram</span>
                    </a>
                  )}
                  {linkedinUrl && (
                    <a href={linkedinUrl} className="social-item" target="_blank" rel="noopener noreferrer">
                      <img src="https://cdn-icons-png.flaticon.com/512/174/174857.png" alt="LinkedIn" />
                      <span>LinkedIn</span>
                    </a>
                  )}
                </div>
              </div>
              <div className="info-item">
                <h4>For Business Inquiries</h4>
                <p>If you're interested in sponsoring the podcast or exploring partnership opportunities, please email us at <a href={`mailto:${businessEmail}`}>{businessEmail}</a></p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;